import { Divider, Skeleton } from "antd"
import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { useNavigate, useParams } from "react-router"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { type ContractListItem } from "../../types/types.ts"
import { ContractsSidebarListItem } from "./ContractsSidebarListItem.tsx"

interface ContractsSidebarListProps {
  hasMore: boolean
  viewLeadAllowed?: boolean
  data: ContractListItem[]
  onLoadMoreContracts: () => void
}

export const ContractsSidebarList = ({
  hasMore,
  viewLeadAllowed,
  data,
  onLoadMoreContracts
}: ContractsSidebarListProps) => {
  const id = useParams()?.id as string
  const navigate = useNavigate()

  const onSelectContract = (id: string) =>
    navigate(RoutesPaths.contract.view(id))

  return (
    <div className={"py-3 flex-1 overflow-hidden"}>
      <div
        id={"scrollableDiv"}
        className={"size-full space-y-3 overflow-auto tailwind-scroll"}
      >
        <InfiniteScroll
          scrollableTarget="scrollableDiv"
          dataLength={data?.length}
          next={onLoadMoreContracts}
          hasMore={hasMore}
          loader={<Skeleton.Node className={"w-full h-32"} active />}
          // endMessage={<Divider plain>It is all, nothing more </Divider>}
          endMessage={<Divider />}
        >
          {data?.map((e) => (
            <ContractsSidebarListItem
              key={e?.id}
              isActive={e?.id == id}
              contract={e}
              viewLeadAllowed={viewLeadAllowed}
              onSelect={onSelectContract}
            />
          ))}
        </InfiniteScroll>
      </div>
    </div>
  )
}
